import React from "react";
import { connect } from "react-redux";
import {withRouter, Link} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";

class StockSummaryReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            filters: {},
            summary: null
        }
    }

    componentDidMount() {
        this.generateReport();
    }

    generateReport = async () => {
        this.setState({loading: true});
        try {
            const response = await apiCall('business/stock/report/summary','post', JSON.stringify(this.state.filters), {
                'Content-Type': 'application/json'
            });
            if(response.status === 'success') {
                this.setState({summary: response.data});
            }
        } catch (e) {
            console.error(e);
        }
        this.setState({loading: false});
    }

    formatCurrency = (amount) => {
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY'
        }).format(amount || 0);
    }

    getMovementTypeLabel = (type) => {
        const types = {
            'purchase': 'Satın Alma',
            'sale': 'Satış',
            'transfer_in': 'Transfer Giriş',
            'transfer_out': 'Transfer Çıkış',
            'adjustment': 'Düzeltme',
            'return': 'İade'
        };
        return types[type] || type;
    }

    getMovementTypeBadge = (type) => {
        const badges = {
            'purchase': 'badge-success',
            'sale': 'badge-danger',
            'transfer_in': 'badge-info',
            'transfer_out': 'badge-warning',
            'adjustment': 'badge-secondary',
            'return': 'badge-primary'
        };
        return badges[type] || 'badge-secondary';
    }

    render() {
        const {loading, summary} = this.state;

        if (!summary) {
            return <div className="text-center p-5">Rapor yüklenemedi.</div>;
        }

        return (
            <div
                style={{flex: 1}}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="page-loader-wrapper" style={{display: loading ? 'block' : 'none'}}>
                        <div className="loader"
                             style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <div className="m-t-30">
                                <img src={require('../../../assets/images/logo-white.png')} width="150"
                                     alt="Servicezone"/>
                            </div>
                            <p>Yükleniyor</p>
                            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Genel Stok Özeti"
                            Breadcrumb={[
                                {name: "Stok Yönetimi", navigate: ""},
                                {name: "Raporlar", navigate: ""},
                                {name: "Genel Özet", navigate: ""},
                            ]}
                        />

                        {/* İstatistik Kartları */}
                        <div className="row clearfix">
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="card">
                                    <div className="body">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div>
                                                <h6 className="mb-0 text-muted">Toplam Stok Kalemi</h6>
                                                <h3 className="mt-2 mb-0 font-weight-bold">{summary.total_items || 0}</h3>
                                                <small className="text-muted">Aktif ürünler</small>
                                            </div>
                                            <div className="icon-in-bg bg-info text-white shadow-sm" style={{
                                                width: '60px',
                                                height: '60px',
                                                borderRadius: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <i className="icon-layers" style={{fontSize: '24px'}}></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="card">
                                    <div className="body">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div>
                                                <h6 className="mb-0 text-muted">Toplam Depo</h6>
                                                <h3 className="mt-2 mb-0 font-weight-bold">{summary.total_warehouses || 0}</h3>
                                                <small className="text-muted">Aktif depolar</small>
                                            </div>
                                            <div className="icon-in-bg bg-secondary text-white shadow-sm" style={{
                                                width: '60px',
                                                height: '60px',
                                                borderRadius: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <i className="icon-home" style={{fontSize: '24px'}}></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="card">
                                    <div className="body">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div>
                                                <h6 className="mb-0 text-muted">Düşük Stok Uyarısı</h6>
                                                <h3 className="mt-2 mb-0 font-weight-bold text-warning">{summary.low_stock_count || 0}</h3>
                                                <small className="text-danger">{summary.out_of_stock_count || 0} Ürün Stokta
                                                    yok</small>
                                            </div>
                                            <div className="icon-in-bg bg-warning text-white shadow-sm" style={{
                                                width: '60px',
                                                height: '60px',
                                                borderRadius: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <i className="icon-bell" style={{fontSize: '24px'}}></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="card">
                                    <div className="body">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div>
                                                <h6 className="mb-0 text-muted">Toplam Stok Değeri</h6>
                                                <h3 className="mt-2 mb-0 font-weight-bold text-success">{this.formatCurrency(summary.total_stock_value)}</h3>
                                                <small className="text-muted">Son 7
                                                    gün: {summary.recent_movements} hareket</small>
                                            </div>
                                            <div className="icon-in-bg bg-success text-white shadow-sm" style={{
                                                width: '60px',
                                                height: '60px',
                                                borderRadius: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <i className="icon-wallet" style={{fontSize: '24px'}}></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Stok Hareket İstatistikleri (Son 30 Gün) */}
                        {summary.movement_stats && Object.keys(summary.movement_stats).length > 0 && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="header">
                                            <h2>Stok Hareketleri <small>Son 30 Gün</small></h2>
                                        </div>
                                        <div className="body">
                                            <div className="row">
                                                {Object.entries(summary.movement_stats).map(([type, stats]) => (
                                                    <div key={type} className="col-lg-2 col-md-4 col-sm-6">
                                                        <div className="card mb-2"
                                                             style={{boxShadow: '0 1px 3px rgba(0,0,0,0.1)'}}>
                                                            <div className="body text-center p-3">
                                                                <span
                                                                    className={`badge ${this.getMovementTypeBadge(type)} mb-2`}>
                                                                    {this.getMovementTypeLabel(type)}
                                                                </span>
                                                                <h4 className="mb-0">{stats.count}</h4>
                                                                <small
                                                                    className="text-muted">{Math.round(stats.total_quantity || 0)} adet</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="row clearfix">
                            {/* Depo Bazlı Özet */}
                            {summary.warehouse_summary && summary.warehouse_summary.length > 0 && (
                                <div className="col-lg-6">
                                    <div className="card">
                                        <div className="header">
                                            <h2>Depo Bazlı Stok Durumu</h2>
                                        </div>
                                        <div className="body">
                                            <div className="table-responsive">
                                                <table className="table table-hover table-vcenter mb-0">
                                                    <thead>
                                                    <tr>
                                                        <th>Depo</th>
                                                        <th className="text-center">Kalem</th>
                                                        <th className="text-center">Miktar</th>
                                                        <th className="text-right">Değer</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {summary.warehouse_summary.map((warehouse, index) => (
                                                        <tr key={index}>
                                                            <td><strong>{warehouse.warehouse_name}</strong></td>
                                                            <td className="text-center"><span
                                                                className="badge badge-primary">{warehouse.item_count}</span>
                                                            </td>
                                                            <td className="text-center">{warehouse.total_quantity}</td>
                                                            <td className="text-right text-success">
                                                                <strong>{this.formatCurrency(warehouse.stock_value)}</strong>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Kategori Bazlı Özet */}
                            {summary.category_summary && summary.category_summary.length > 0 && (
                                <div className="col-lg-6">
                                    <div className="card">
                                        <div className="header">
                                            <h2>Kategori Bazlı Stok Durumu</h2>
                                        </div>
                                        <div className="body">
                                            <div className="table-responsive">
                                                <table className="table table-hover table-vcenter mb-0">
                                                    <thead>
                                                    <tr>
                                                        <th>Kategori</th>
                                                        <th className="text-center">Kalem Sayısı</th>
                                                        <th className="text-right">Toplam Miktar</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {summary.category_summary.map((category, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <strong>{category.category_name || 'Kategorisiz'}</strong>
                                                            </td>
                                                            <td className="text-center"><span
                                                                className="badge badge-info">{category.item_count}</span>
                                                            </td>
                                                            <td className="text-right">{category.total_quantity}</td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="row clearfix">
                            {/* Düşük Stok Uyarıları */}
                            {summary.low_stock_items && summary.low_stock_items.length > 0 && (
                                <div className="col-lg-6">
                                    <div className="card">
                                        <div className="header">
                                            <h2>Düşük Stok Uyarıları <small>İlk 10</small></h2>
                                            <ul className="header-dropdown">
                                                <li>
                                                    <Link to="/stock/reports/low-stock"
                                                          className="btn btn-sm btn-warning">
                                                        <i className="icon-share-alt text-white"></i>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="body">
                                            <div className="table-responsive">
                                                <table className="table table-hover table-vcenter mb-0">
                                                    <thead>
                                                    <tr>
                                                        <th>Depo</th>
                                                        <th>Ürün</th>
                                                        <th className="text-center">Mevcut</th>
                                                        <th className="text-center">Min</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {summary.low_stock_items.map((item, index) => (
                                                        <tr key={index}>
                                                            <td><small>{item.warehouse_name}</small></td>
                                                            <td><strong>{item.item_name}</strong></td>
                                                            <td className="text-center">
                                                                    <span
                                                                        className={`badge ${item.current_stock === 0 ? 'badge-danger' : 'badge-warning'}`}>
                                                                        {item.current_stock}
                                                                    </span>
                                                            </td>
                                                            <td className="text-center">{Math.round(item.min_stock || 0)}</td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Son Hareketler */}
                            {summary.recent_movements_list && summary.recent_movements_list.length > 0 && (
                                <div className="col-lg-6">
                                    <div className="card">
                                        <div className="header">
                                            <h2>Son Hareketler <small>İlk 10</small></h2>
                                            <ul className="header-dropdown">
                                                <li>
                                                    <Link to="/stock/movements" className="btn btn-sm btn-primary">
                                                        <i className="icon-share-alt text-white"></i>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="body">
                                            <div className="table-responsive">
                                                <table className="table table-hover table-vcenter mb-0">
                                                    <thead>
                                                    <tr>
                                                        <th>Tarih</th>
                                                        <th>Depo</th>
                                                        <th>Ürün</th>
                                                        <th className="text-center">Tip</th>
                                                        <th className="text-right">Miktar</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {summary.recent_movements_list.map((movement, index) => (
                                                        <tr key={index}>
                                                            <td><small>{movement.movement_date}</small></td>
                                                            <td><small>{movement.warehouse_name}</small></td>
                                                            <td><strong>{movement.item_name}</strong></td>
                                                            <td className="text-center">
                                                                    <span
                                                                        className={`badge ${this.getMovementTypeBadge(movement.movement_type)}`}>
                                                                        {this.getMovementTypeLabel(movement.movement_type)}
                                                                    </span>
                                                            </td>
                                                            <td className="text-right">{Math.round(movement.quantity || 0)}</td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(StockSummaryReport));




